<template>
  <div class="min-h-screen bg-background p-6 pb-24 pt-safe">
    <!-- Header -->
    <div class="flex items-center gap-4 mb-6 mt-12">
      <button
        @click="router.back()"
        class="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center active:scale-95"
      >
        <span class="text-xl">←</span>
      </button>
      <h1 class="text-xl font-bold text-textMain">使用條款</h1>
    </div>

    <div class="bg-white rounded-2xl shadow-sm p-6 space-y-6">
      <p class="text-xs text-textMuted">最後更新日期：2024 年 12 月 18 日</p>

      <p class="text-sm text-textMain leading-relaxed">
        歡迎使用「寶寶接種小幫手」（以下簡稱「本應用程式」）。使用本應用程式即表示您同意以下條款。
      </p>

      <section>
        <h2 class="font-bold text-textMain mb-2">1. 服務說明</h2>
        <p class="text-sm text-textMuted leading-relaxed">本應用程式提供以下功能：</p>
        <ul class="text-sm text-textMuted list-disc pl-5 mt-2 space-y-1">
          <li>記錄寶寶的基本資料</li>
          <li>自動計算疫苗接種時程</li>
          <li>追蹤疫苗接種記錄</li>
          <li>發送接種提醒通知</li>
          <li>多裝置間同步資料</li>
        </ul>
      </section>

      <div class="bg-amber-50 border-l-4 border-amber-400 p-4 rounded-r-xl">
        <p class="text-sm font-bold text-amber-900 mb-1">⚠️ 重要聲明</p>
        <p class="text-sm text-amber-800">
          本應用程式僅供參考，不構成醫療建議。疫苗接種時程可能因政策變動或個人健康狀況而有所不同。實際接種前，請務必諮詢您的兒科醫師或衛生機關。
        </p>
      </div>

      <section>
        <h2 class="font-bold text-textMain mb-2">2. 使用者帳號</h2>
        <ul class="text-sm text-textMuted list-disc pl-5 space-y-1">
          <li>您可以使用匿名帳號或電子郵件帳號使用本應用程式</li>
          <li>您有責任保管好您的帳號密碼</li>
          <li>匿名帳號的資料僅存於當前裝置，更換裝置可能導致資料遺失</li>
          <li>建議您建立電子郵件帳號以備份資料</li>
        </ul>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">3. 使用者責任</h2>
        <ul class="text-sm text-textMuted list-disc pl-5 space-y-1">
          <li>提供正確的寶寶出生日期，以確保時程計算準確</li>
          <li>不得將本應用程式用於任何非法目的</li>
          <li>不得嘗試破解、修改或干擾本應用程式的運作</li>
        </ul>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">4. 智慧財產權</h2>
        <p class="text-sm text-textMuted leading-relaxed">
          本應用程式及其內容（包括但不限於設計、圖示、程式碼）均受著作權法保護。未經授權，不得複製、修改或散佈。
        </p>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">5. 免責聲明</h2>
        <ul class="text-sm text-textMuted list-disc pl-5 space-y-1">
          <li>本應用程式依「現況」提供，不提供任何明示或暗示的保證</li>
          <li>我們不保證服務不會中斷或沒有錯誤</li>
          <li>對於因使用本應用程式而產生的任何損害，我們不承擔責任</li>
          <li>疫苗資訊僅供參考，實際接種請遵循醫療專業人員的建議</li>
        </ul>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">6. 服務變更與終止</h2>
        <ul class="text-sm text-textMuted list-disc pl-5 space-y-1">
          <li>我們保留隨時修改或終止服務的權利</li>
          <li>重大變更將透過應用程式通知使用者</li>
          <li>您可以隨時刪除帳號停止使用本服務</li>
        </ul>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">7. 條款變更</h2>
        <p class="text-sm text-textMuted leading-relaxed">
          我們可能會不定期更新本使用條款。繼續使用本應用程式即表示您接受更新後的條款。
        </p>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">8. 準據法</h2>
        <p class="text-sm text-textMuted leading-relaxed">
          本條款受中華民國法律管轄。如有爭議，以台灣台北地方法院為第一審管轄法院。
        </p>
      </section>

      <section class="bg-gray-50 rounded-xl p-4">
        <h2 class="font-bold text-textMain mb-2">9. 聯絡我們</h2>
        <p class="text-sm text-textMuted">如有任何問題或建議，請透過以下方式聯絡我們：</p>
        <p class="text-sm text-primary mt-1">📧 igoouttw@gmail.com</p>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()
</script>
